import React from 'react';
import { Flex } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { SkeletonText, SkeletonThumbnail } from '@shared/components/Skeleton';
import { TILE_THUMBNAIL_WIDTH, TILE_THUMBNAIL_BORDER_RADIUS, TILE_BORDER_RADIUS, SKELETON_TILE_COUNT, TILE_THUMBNAIL_HEIGHT } from './HotelTile.constants';

export const HotelTileSkeleton: React.FC = React.memo(() => (
  <Flex
    alignItems="stretch"
    width="100%"
    border="1px solid"
    borderColor="mono3"
    borderRadius={pxToRem(TILE_BORDER_RADIUS)}
    minHeight={pxToRem(TILE_THUMBNAIL_HEIGHT)}
  >
    <SkeletonThumbnail
      overrides={{
        PlaceholderRoot: {
          props: {
            width: pxToRem(TILE_THUMBNAIL_WIDTH),
            height: pxToRem(TILE_THUMBNAIL_HEIGHT),
            minWidth: pxToRem(TILE_THUMBNAIL_WIDTH),
            alignSelf: 'stretch',
            borderTopLeftRadius: pxToRem(TILE_THUMBNAIL_BORDER_RADIUS),
            borderBottomLeftRadius: pxToRem(TILE_THUMBNAIL_BORDER_RADIUS),
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
        },
      }}
    />
    <Flex
      flex={1}
      flexDirection="column"
      justifyContent="space-between"
      minWidth={0}
      paddingY={3}
      paddingX={4}
    >
      {/* Top: name + metadata */}
      <Flex
        flexDirection="column"
        gap={pxToRem(6)}
      >
        <SkeletonText
          rows={1}
          width="80%"
          skeletonHeight={pxToRem(21)}
        />
        <SkeletonText
          rows={1}
          width="50%"
          skeletonHeight={pxToRem(16)}
        />
        <SkeletonText
          rows={1}
          width="70%"
          skeletonHeight={pxToRem(16)}
        />
      </Flex>
      {/* Bottom: tag + pricing */}
      <Flex
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <SkeletonText
          rows={1}
          width="45%"
          skeletonHeight={pxToRem(16)}
        />
        <Flex
          flexDirection="column"
          alignItems="flex-end"
          gap={1}
          flexShrink={0}
        >
          <SkeletonText
            rows={1}
            width={pxToRem(55)}
            skeletonHeight={pxToRem(24)}
          />
          <SkeletonText
            rows={1}
            width={pxToRem(75)}
            skeletonHeight={pxToRem(14)}
          />
        </Flex>
      </Flex>
    </Flex>
  </Flex>
));

HotelTileSkeleton.displayName = 'HotelTileSkeleton';

export const HotelTileSkeletonList: React.FC = React.memo(() => (
  <Flex
    flexDirection="column"
    gap={7}
  >
    {Array.from({ length: SKELETON_TILE_COUNT }).map((_, i) => (
      <HotelTileSkeleton key={i} />
    ))}
  </Flex>
));

HotelTileSkeletonList.displayName = 'HotelTileSkeletonList';
